export const CellWithDividerStyle = {
  position: "relative",
  ":after": {
    content: `""`,
    position: "absolute",
    right: 0,
    top: "1rem",
    bottom: "1rem",
    width: "1px",
    borderRightWidth: "thin",
    borderRightStyle: "solid",
    borderRightColor: "grey.300",
  },
};

export const TableContainerStyle = {
  backgroundColor: "grey.50",
  borderTop: "1px solid var(--DataGrid-t-color-border-base)",
};

export const TableBodyStyle = {
  "& > tr:last-child > td": {
    borderBottom: "none",
  },
};

export const CellHeaderSeparatorStyle = {
  backgroundColor: "grey.100",
  py: 1,
  px: 2,
};

export const ConditionSeparatorStyle = {
  pt: 1,
  borderTopWidth: "thin",
  borderTopStyle: "solid",
  borderTopColor: "grey.300",
};
